import {
  ApiOutlined,
  CheckOutlined,
  HourglassOutlined,
} from "@ant-design/icons";
import { Tooltip, theme } from "antd";
import { Availability } from "pages/api/deep-links/types";
import { CSSProperties } from "react";

export const AvailabilityStatus = (props: {
  availability?: Availability;
  textual?: boolean;
  style?: CSSProperties;
}) => {
  const { token } = theme.useToken();

  return props.availability ? (
    <div
      style={{
        color: token.colorTextSecondary,
        paddingBottom: 16,
        ...props.style,
      }}
    >
      {props.availability.configured ? (
        props.availability.populated ? (
          <Tooltip title="all integrations configured, all entities are populated">
            <CheckOutlined />
            {props.textual ? " Populated" : ""}
          </Tooltip>
        ) : (
          <Tooltip title="all integrations configured, some entities are not yet populated">
            <HourglassOutlined />
            {props.textual ? " Processing" : ""}
          </Tooltip>
        )
      ) : (
        <Tooltip title="necessary integrations are not configured">
          <ApiOutlined />
          {props.textual ? " Missing" : ""}
        </Tooltip>
      )}
    </div>
  ) : null;
};

export const compare = (
  a: Availability | undefined,
  b: Availability | undefined
): number => {
  const score = (x: Availability | undefined) =>
    x?.populated ? -1 : x === undefined ? 0 : x.configured ? 1 : 2;
  return score(a) - score(b);
};
